import { Button, Typography } from 'antd'
import React from 'react'
import { DraftsQueueSummaryRow as SummaryRowData } from '../utils/drafts-queue-rows'

const { Text } = Typography

const describeHidden = ({
  hiddenCount,
  isExpanded,
}: SummaryRowData): string | null => {
  if (isExpanded) {
    // Show all lists only the first fetched page of uploads
    return hiddenCount > 0 ? `${hiddenCount} more not shown` : null
  }
  const noun = hiddenCount === 1 ? 'upload' : 'uploads'
  return `+${hiddenCount} more ${noun} in progress`
}

// Full-width pinned row under the first few unfinished uploads
function DraftsQueueSummaryRow({
  data,
  onToggle,
}: {
  data: SummaryRowData
  onToggle: () => void
}) {
  const label = describeHidden(data)
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        height: '100%',
        paddingLeft: '16px',
      }}
    >
      {label && <Text className="textSm textGray">{label}</Text>}
      <Button type="link" onClick={onToggle}>
        {data.isExpanded ? 'Show less' : 'Show all'}
      </Button>
    </div>
  )
}

export default DraftsQueueSummaryRow
